/**
 * @file JS - main.js
 * @author : Adam Lemire
 * @since 2019/06/08
 * @version 1.0
 * @summary Dernières modifications : 2023/01/25
 * voir helpers/Selectors pour ce qui est relatif aux sélecteurs html du projet
 */

import 'core-js/features/promise';
import 'regenerator-runtime/runtime';
import { gisSettings } from './gisSettings.js'; /* eslint-disable-line no-unused-vars */
import GisController from './controllers/GisController.js';
import 'ol/ol.css';

$(function () {
  const gisController = new GisController(gisSettings.versionSig);
  gisController.activer();
});
